import styled from 'styled-components';
import theme from '../../theme';

export const Container = styled.div`
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: ${theme.spacing['4xl']} ${theme.spacing['5xl']} 44px;
`

export const ContentContainer = styled.div`
  height: 100%;
  width: 100%;
  max-width: 1200px;
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
`
